module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/13-a5e6776590d2ec086f37b4da198dd780.jpg";